import React from 'react';

const Error = ({message}) => {
    return ( 
        <p className="my-3 py-4 text-center alert alert-primary">{message}</p>
     );
}
 
export default Error;